import { render } from "./SalaryExportsHistoryDataTable.vue?vue&type=template&id=4fbb274a&ts=true"
import script from "./SalaryExportsHistoryDataTable.vue?vue&type=script&lang=ts"
export * from "./SalaryExportsHistoryDataTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__